const Page_PrivacyPolicy = () => {

    return(
        <>
            <h1 className="text-2xl font-extrabold dark:text-white">Privacy Policy</h1>
            <p>
                We are committed to protecting your personal data and handling it responsibly.
            </p>
            <br/>
            <h2 className="text-1xl font-bold dark:text-white">GDPR Compliance</h2>
            <p>
                This app is GDPR compliant. Personal data is processed lawfully, fairly, and transparently,
                and only for legitimate purposes.
            </p>
        </>
    );
}

export default Page_PrivacyPolicy;